import { render } from "./CallRequestCard.vue?vue&type=template&id=b4968332"
import script from "./CallRequestCard.vue?vue&type=script&lang=js"
export * from "./CallRequestCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__